var Hydrotip = function Hydrotip() {
  var navigate = useNavigate();
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage__hydrotip",
    onMouseEnter: function onMouseEnter() {
      $('.landingpage__hydrotip--ro').css({
        opacity: 1
      });
    },
    onMouseLeave: function onMouseLeave() {
      $('.landingpage__hydrotip--ro').css({
        opacity: 0
      });
    },
    onClick: function onClick() {
      return navigate('/hydrotip');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/HydroTip_Homepage-Chip.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__hydrotip--ro"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/HydroTip_Homepage-Chip-RO.png"
  })));
};
export default Hydrotip;